import { render, staticRenderFns } from "./CarActivity.vue?vue&type=template&id=4a88f900&scoped=true&"
import script from "./CarActivity.vue?vue&type=script&lang=js&"
export * from "./CarActivity.vue?vue&type=script&lang=js&"
import style0 from "./CarActivity.vue?vue&type=style&index=0&id=4a88f900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88f900",
  null
  
)

export default component.exports